import request from '@/utils/request'

// 获取模块
export function getModule(params) {
  return request({
    url: '/ework2/cmsApi/module/list',
    method: 'get',
    params
  })
}

// 获取banner
export function getBanner(params) {
  return request({
    url: '/ework2/cmsApi/banner/list',
    method: 'get',
    params
  })
}

// 获取 search
export function getSearch(params) {
  return request({
    url: '/ework2/cmsApi/search/query',
    method: 'get',
    params
  })
}

// 获取栏目
export function getColumn(params) {
  return request({
    url: '/ework2/cmsApi/column/list',
    method: 'get',
    params
  })
}

// 获取 activity
export function getActivity(params) {
  return request({
    url: '/ework2/cmsApi/activity/list',
    method: 'get',
    params
  })
}

// 获取 article
export function getArticle(params) {
  return request({
    url: '/ework2/cmsApi/article/list',
    method: 'get',
    params
  })
}
export function getArticleType(params) {
  return request({
    url: '/ework2/cmsApi/article/listByType',
    method: 'get',
    params
  })
}
// 获取菜单
export function getMenu(params) {
  return request({
    url: '/ework2/cmsApi/menu/list',
    method: 'get',
    params
  })
}


// 获取 articleDetails
export function getArticleDetails(params) {
  return request({
    url: '/ework2/cmsApi/article/query',
    method: 'get',
    params
  })
}

// 点赞
export function articleLike(params) {
  return request({
    url: '/ework2/cmsApi/like/do',
    method: 'post',
    params
  })
}

// 收藏
export function articleCollect(params) {
  return request({
    url: '/ework2/cmsApi/collection/do',
    method: 'post',
    params
  })
}

// 获取 articleSearch
export function articleSearch(params) {
  return request({
    url: '/ework2/cmsApi/article/search',
    method: 'get',
    params
  })
}

// 我的收藏  myCollection
export function myCollection(params) {
  return request({
    url: '/ework2/cmsApi/collection/myCollection',
    method: 'get',
    params
  })
}

// 获取 getFilters
export function getFilters(params) {
  return request({
    url: '/ework2/cmsApi/article/getFilters',
    method: 'get',
    params
  })
}

// 获取 commentsAdd
export function commentsAdd(params) {
  return request({
    url: '/ework2/cmsApi/comments/add',
    method: 'post',
    params
  })
}

// 获取 commentsList  
export function commentsList(params) {
  return request({
    url: '/ework2/cmsApi/comments/list',
    method: 'get',
    params
  })
}
